import { createFileRoute } from "@tanstack/react-router";
import { NewRecipePage } from "./-NewRecipePage";

export const Route = createFileRoute("/_app/_recipe-page/recipes/new")({
  component: NewRecipePage,
});
